<script lang="ts">
  // Full-screen Settings route for Free Duel, which has no overworld to overlay onto. It renders the
  // shared SettingsPanel over the animated cyber background. World uses the SettingsDialog overlay
  // instead (the player stays on the map), but both reuse the same rows, gated by session.mode.
  import { fade, fly } from "svelte/transition";
  import { expoOut } from "svelte/easing";
  import { session, go } from "../stores/session.svelte.ts";
  import DataWindow from "../components/ui/DataWindow.svelte";
  import SettingsPanel from "../components/SettingsPanel.svelte";
  import { onEscape } from "../hotkeys.ts";

  const backRoute = $derived(session.mode === "free" ? ("freeduel" as const) : ("world" as const));
  const backLabel = $derived(session.mode === "free" ? "Free Duel" : "World");
  function back() {
    go(backRoute);
  }
  onEscape(() => back());

  const reduced = typeof matchMedia !== "undefined" && matchMedia("(prefers-reduced-motion: reduce)").matches;
  const d = (ms: number) => (reduced ? 0 : ms);
</script>

<div class="relative flex h-full w-full items-center justify-center overflow-hidden px-4 py-5 sm:py-8">
  <div class="flex h-full w-full max-w-[34rem] flex-col gap-4">
    <!-- Back bar -->
    <div class="flex shrink-0 items-center justify-between" in:fade={{ duration: d(400) }}>
      <button
        onclick={back}
        class="flex items-center gap-1.5 chamfer-btn bg-surface/70 px-3 py-2 font-display text-xs font-semibold uppercase tracking-[0.14em] text-ink-dim transition-colors hover:text-cyan"
        style="--c:7px"
      >
        <svg viewBox="0 0 24 24" class="size-3.5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5" /><path d="m11 18-6-6 6-6" /></svg>
        {backLabel}
      </button>
    </div>

    <!-- Title -->
    <header class="mt-1 shrink-0" in:fly={{ y: 16, duration: d(520), delay: d(80), easing: expoOut }}>
      <h1 class="font-display text-[clamp(1.7rem,5vw,2.6rem)] font-bold uppercase leading-none tracking-[0.04em] text-ink">
        Settings
      </h1>
      <p class="mt-1.5 text-sm text-ink-dim">Audio, animations & preferences.</p>
    </header>

    <!-- Panel — the window itself scrolls (the page never does). -->
    <div class="min-h-0 flex-1" in:fly={{ y: 22, duration: d(560), delay: d(160), easing: expoOut }}>
      <DataWindow c={16} fill class="flex flex-col">
        <div class="min-h-0 flex-1 overflow-y-auto scroll-cyber">
          <SettingsPanel />
        </div>
      </DataWindow>
    </div>
  </div>
</div>
